"use client"

import { useEffect } from "react"

export default function OpenCookieSettings({ shouldOpen }: { shouldOpen: boolean }) {
  useEffect(() => {
    if (shouldOpen) {
      window.dispatchEvent(new CustomEvent("fp51:open-cookie-settings"))
    }
  }, [shouldOpen])

  return null
}
